export default __webpack_public_path__ + "static/media/greenbiscuit.da3d4d6d.png";